module.exports = __webpack_public_path__ + "img/notebook.771528c8.png";